export const DEFAULT_QUERY_OPTIONS = {
	staleTime: 1000 * 10 // 10 seconds
};
